import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IMAGE_SRC, VALIDATION_MESSAGE } from '../../../shared-constants';

@Component({
  selector: 'app-form-time-picker',
  templateUrl: './form-time-picker.component.html',
  styleUrls: ['./form-time-picker.component.scss'],
  standalone: false,
})
export class FormTimePickerComponent {
  @Input() headerText!: string;
  @Input() form!: FormGroup;
  @Input() control!: string;
  @Input() icon = IMAGE_SRC.CLOCK;
  @Input() defaultStartTime = '00:00';
  @Input() required = true;
  @Input() altIconSpacing = false;
  @Input() placeholderText = this.defaultStartTime;
  @Output() inputChangedEvent = new EventEmitter();

  readonly CONSTS = IMAGE_SRC;
  readonly ERROR_CONSTANTS = VALIDATION_MESSAGE;

  /**
   * Updates form control value when time is selected from picker
   * @param $event - Selected time string in HH:mm format
   */
  inputChanged(time: string) {
    const ctrl = this.form.get(this.control);
    if (!ctrl) return;

    ctrl.setValue(time);
    ctrl.markAsTouched();
    ctrl.markAsDirty();
    this.inputChangedEvent.emit(time);
  }

  // Formats the input value to HH:mm format as the user types
  fixTimeFormat() {
    let formValue = this.form.get(this.control);
    let inputValue = formValue?.value?.replace(/\D/g, '');

    if (inputValue.length > 4) {
      inputValue = inputValue.substring(0, 4);
    }

    if (inputValue.length >= 3) {
      inputValue = inputValue.substring(0, 2) + ':' + inputValue.substring(2);
    }

    formValue?.setValue(inputValue);
    formValue?.updateValueAndValidity({ onlySelf: true });
  }

  // Validates the time format on blur and resets the value if it's invalid
  validateTimeOnBlur() {
    const formValue = this.form.get(this.control);
    const value = formValue?.value;

    if (!value || value.length < 4) {
      formValue?.setValue('');
      return;
    }

    const [h, m] = value.split(':').map(Number);

    const isValid =
      Number.isInteger(h) &&
      Number.isInteger(m) &&
      h >= 0 &&
      h <= 23 &&
      m >= 0 &&
      m <= 59;

    if (!isValid) {
      const now = new Date();
      const normalizedTime = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
      formValue?.setValue(normalizedTime);
    } else {
      // Normalize the time format with leading zeros
      const normalizedTime = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
      formValue?.setValue(normalizedTime);
    }
  }
}
